var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.formattedData)?_c(_setup.GeoJsonSource,{attrs:{"source-id":_setup.sourceName,"data":_setup.formattedData}},[_c(_setup.LayerGroup,{attrs:{"layers":_setup.layers,"debug":['job-breadcrumb-circle', 'job-breadcrumb-bearing'],"get-debug-contents":_setup.getHoverContent}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }